// Added by Sejune Oh on 2020-02-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Box as MaterialUIBox,
    BoxProps as MaterialUIBoxProps
} from '@material-ui/core'

interface BoxBaseProps { }
export type BoxProps = Partial<MaterialUIBoxProps> & BoxBaseProps

export const Box: FC<BoxProps> = ({ ...props }) => {
    return <MaterialUIBox {...props}></MaterialUIBox>
}
